import React from 'react';
import PropTypes from 'prop-types';

import BreedOverviewSectionContent from './BreedOverviewSectionContent';

export default function BreedOverviewSection({
  header,
  subheader,
  content,
  ContentComponent,
  photo,
  id
}) {
  return (
    <div className="BreedOverviewSection row ph5 pv5 ph20-md pv0-lg" id={id}>
      <div className="col-12 col-lg-8 mx-auto">
        <h2 className="mb4 mb12-md f6 f8-md lh-title">{header}</h2>
        {ContentComponent ? (
          <ContentComponent />
        ) : (
          <BreedOverviewSectionContent
            content={content}
            photo={photo}
            subheader={subheader}
          />
        )}
      </div>
    </div>
  );
}

BreedOverviewSection.propTypes = {
  header: PropTypes.string.isRequired,
  subheader: PropTypes.string,
  content: PropTypes.string,
  ContentComponent: PropTypes.func,
  photo: PropTypes.shape({
    photo_url: PropTypes.string.isRequired,
    source_url: PropTypes.string,
    source_name: PropTypes.string,
    alt_text: PropTypes.string
  }),
  id: PropTypes.string
};

BreedOverviewSection.defaultProps = {
  subheader: null,
  content: null,
  ContentComponent: null,
  photo: null,
  id: ''
};
